import * as filterActions from "../shared/actions/filters";
import { SWITCH_TO_REGULATION_DETAIL } from "./actions/focus_view";

// apply filter when focusing regulation view
export const applyRegulationStandardsListFilter = store => next => action => {
  if (action.type === SWITCH_TO_REGULATION_DETAIL) {
    const regulationId = action.payload.regulations[0].id;

    store.dispatch(filterActions.focusRegulationId(regulationId));
  }

  return next(action);
};
